import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from '../../../../../../Autofacets-Core/src/app/common-services/global-setting.service';
import { DealerPartViewModel } from '../../../business-entities/dealer-part-view-model';
import { PartsListViewModel } from '../../../business-entities/parts-list-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerPartsService } from '../../../business-services/dealer-parts.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-edit-dealer-parts',
  templateUrl: './edit-dealer-parts.component.html'
})
export class EditDealerPartsComponent implements OnInit {
  editDealerPartsForm: FormGroup;
  dealerList: SelectListItemViewModel[];
  part: DealerPartViewModel;
  SelectedDealer: string;
  SelectedParts: string;
  partsId: any;
  partsList: PartsListViewModel[];
  unitPrice:string;
  constructor(private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private dealerPartService: DealerPartsService,
    private toaster: ToastrService,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private globalSetting: GlobalSetting,private activeModal : NgbActiveModal) { }

  ngOnInit(): void {
    this.dealerList = this.dealerPartService.dealerList;
    this.getDealerPartsList()
    let dealerPartId = this.dealerPartService.dealerPartId;
    this.editDealerPartsForm = this.formBuilder.group({
      dealerName: [null, [Validators.required]],
      partNumber: [null, [Validators.required]],
      convertToPartNumber: [''],
      unitPrice: [''],
      isActive: [false],
      quantity: [null, [Validators.required]]
    });
    this.editDealerPartsForm.get('dealerName').disable();
    this.editDealerPartsForm.get('partNumber').disable();
    this.getDealerPartById(dealerPartId);

  }

  get cpf() {
    return this.editDealerPartsForm.controls;
  }
  async getDealerPartsList() {
    this.partsList = this.dealerPartService.partsList;
  }

  async getDealerPartById(Id: number) {

    if (Id) {
      this.spinner.show();
      let viewModel ={
        Id: Id,
        LanguageCode:this.cookieservice.get('userSelectedLanguage')
      }
      await this.dealerPartService.getDealerPartById(viewModel).then((response) => {
        this.part = response.responseObject;
        let unitPrice = this.globalSetting.getFormattedprice(this.part.unitPrice.toString());
        this.editDealerPartsForm.patchValue({
          unitPrice: unitPrice,
          partNumber: this.part.partNumber,
          dealerName: this.part.dealerId,
          isActive: this.part.isActive,
          quantity: this.part.quantity
        });
        this.unitPrice=unitPrice;
      },_error => {
        this.spinner.hide();
      });
      this.spinner.hide();
    }
  }
  onBlur(event){
    this.unitPrice=event.target.value;
  }
  updateDealerParts() {
    const partNumber = this.editDealerPartsForm.get('partNumber').value;
    const parts = this.partsList.find(x => x.partNumber === partNumber);
    const unitPrice = this.editDealerPartsForm.get('unitPrice').value;
    if (unitPrice > this.part.adminUnitPrice) {
      this.editDealerPartsForm.controls.unitPrice.setErrors({ unitPriceFlag: true });

    }
    else {
      this.spinner.show();
      this.editDealerPartsForm.controls.unitPrice.setErrors(null)
      let viewModel =
      {
        Id: this.part.id,
        DealerId: this.SelectedDealer.toString(),
        PartId: parts.id,
        PartNumber:this.editDealerPartsForm.get('partNumber').value,
        ConvertToPartNumber: this.editDealerPartsForm.get('convertToPartNumber').value,
        UnitPrice: +this.globalSetting.getFormattedprice(this.editDealerPartsForm.get('unitPrice').value),
        IsActive: this.editDealerPartsForm.get('isActive').value,
        CreatedBy: '',
        TotalQuantity: +this.editDealerPartsForm.get('quantity').value
      }
      this.dealerPartService.updateDealerParts(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.activeModal.close({ success: true });
          let successMsg = this.translate.instant("lblPartUpdated");
          this.toaster.success(successMsg);
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {

          let errorErr = this.translate.instant("lblPartExist");
          this.toaster.warning(errorErr);
        }
        this.spinner.hide();
      });
      this.spinner.hide();
    }

  }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }

}
